import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { analyticsTrack } from '../../../analyticsUtils';
import { putRequest, deleteRequest } from '../../../requestUtils';
import { listElementsToArray } from '../../../responsibilitiesUtils';
import '../ProjectDetails.scss';
import './ProjectReview.scss';
import AddCoworkersModal from '../../AddCoworkersModal';
import ProjectLoadingIndicator from '../ProjectLoadingIndicator';
import FeaturedProfileBanner from '../FeaturedProfileBanner/FeaturedProfileBanner';
import AdminModal from '../AdminModal';
import dollar from '../../../../assets/images/icons/dollar.svg';
import mapIcon from '../../../../assets/images/icons/location.svg';
import travelPlane from '../../../../assets/images/icons/travel-plane.svg';
import clock from '../../../../assets/images/icons/clock-dark.svg';
import calender from '../../../../assets/images/icons/calender.svg';
import ProjectDetailsNav from '../ProjectDetailsNav';
import ProjectBudgetLogisticsView from '../../common/ProjectBudgetLogisticsView';
import LengthOfEngagement from '../../common/LengthOfEngagement';
import JobRoleAndTitleView from '../../common/RoleAndTitleView';

const formStep = 'review';

const processTakeRate = (takeRate) => {
  if (!takeRate) return 25.0;
  return Math.round(takeRate * 10000) / 100;
};

const cssClass = (showFullTimeOption) => (showFullTimeOption ? 'new-summary-section' : 'summary-section');

class ProjectReview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      projectDetails: null,
      teamModalViewed: false,
      pageSubmitted: false,
      openTeamModal: false,
      loading: false,
      showConfirmDeletion: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSaveDraft = this.handleSaveDraft.bind(this);
    this.handleDeleteProject = this.handleDeleteProject.bind(this);
    this.updateProjectDetails = this.updateProjectDetails.bind(this);
    this.handleExit = this.handleExit.bind(this);
    this.handleAfterPublish = this.handleAfterPublish.bind(this);
  }

  componentDidMount() {
    const { projectResourceId } = this.props;

    if (!projectResourceId) return;

    this.updateProjectDetails();
  }

  updateProjectDetails() {
    const { getProjectDetails } = this.props;

    getProjectDetails(formStep).then((response) => {
      this.setState({
        projectDetails: response.data,
        teamModalViewed: response.data.initial_team_members.team_members.length !== 1,
      });
    });
  }

  isProjectDraft() {
    return this.state.projectDetails.status === 'employer_draft';
  }

  handleSaveDraft() {
    this.setState({ loading: true });
    window.location.href = this.state.projectDetails.save_draft_path;
  }

  handleDeleteProject() {
    const deleteProjectPath = this.state.projectDetails.delete_project_path;
    const projectIndexPath = this.state.projectDetails.project_index_path;
    const { csrfToken, steps, userId } = this.props;

    analyticsTrack(
      'Project deleted from review page',
      {
        location: 'Project creation',
        eventId: 'Delete project from review',
        eventType: 'buttonClick',
        timestamp: Date.now(),
        buttonId: 'review-page-delete-project',
        buttonLabel: 'Delete Project',
        wizardStep: steps.length,
        wizardTotalSteps: steps.length,
        userId,
      },
    );

    deleteRequest(deleteProjectPath, csrfToken).then(() => {
      this.setState({ loading: true });
      window.location.href = projectIndexPath;
    });
  }

  handleSubmit() {
    const {
      csrfToken,
      projectResourceId,
      steps,
      userId,
    } = this.props;

    if (this.isProjectDraft()) {
      putRequest(
        `/projects/${projectResourceId}/publish`,
        { resource_id: projectResourceId },
        csrfToken,
      ).then(() => {
        analyticsTrack(
          'Project submitted to Clora from review page',
          {
            location: 'Project creation',
            eventId: 'Submit from review',
            eventType: 'buttonClick',
            timestamp: Date.now(),
            buttonId: 'review-page-submit',
            buttonLabel: 'Submit Project',
            wizardStep: steps.length,
            wizardTotalSteps: steps.length,
            userId,
          },
        );
        this.setState({ pageSubmitted: true }, this.handleAfterPublish);
      }).catch((error) => {
        window.location.href = '#';
        this.setState({ errors: error });
      });
    } else {
      putRequest(
        `/projects/${projectResourceId}`,
        { resource_id: projectResourceId },
        csrfToken,
      ).catch((error) => {
        window.location.href = '#';
        this.setState({ errors: error });
      });
      window.location.href = `/projects/${projectResourceId}`;
    }
  }

  handleAfterPublish() {
    const { projectResourceId } = this.props;
    const { pageSubmitted, teamModalViewed } = this.state;

    const projectShowUrl = `/projects/${projectResourceId}`;
    if (pageSubmitted && teamModalViewed) {
      window.location.href = projectShowUrl;
    } else if (pageSubmitted) {
      this.setState({ openTeamModal: true });
    }
  }

  travelLocationText() {
    const { projectDetails } = this.state;

    if (projectDetails.travel_time === 'travel' || projectDetails.travel_locations[0]) {
      return `Travel Requirements - ${projectDetails.travel_locations[0]}`;
    }
    return 'Travel Requirements - N/A';
  }

  hoursText() {
    const { projectDetails } = this.state;

    if (!projectDetails.avg_time_required_range || projectDetails.avg_time_required_range === 'not sure') return 'Hours';

    return `${projectDetails.avg_time_required_range} working hours per week`;
  }

  durationText() {
    const { projectDetails } = this.state;

    if (!projectDetails.duration_range || projectDetails.duration_range === 'not sure') return 'Duration';
    return `${projectDetails.duration_range} month duration`;
  }

  sectionWarning(section) {
    const { steps } = this.props;
    const { projectDetails } = this.state;
    let warningText = '';

    if (!projectDetails.abandoned_at) return null;

    if (projectDetails.abandoned_at === 'budget'
         || projectDetails.abandoned_at === 'logistics') {
      if (section === 'Budget & Logistics'
            && (!projectDetails.work_location
            || !projectDetails.travel_time
            || !projectDetails.budget_minimum
            || !projectDetails.budget_maximum)) {
        warningText = 'Please complete section';
      } else {
        return null;
      }
    } else if (steps.indexOf(section.toLowerCase())
               === steps.indexOf(projectDetails.abandoned_at)) {
      warningText = 'Please complete section';
    } else if (steps.indexOf(section.toLowerCase()) > steps.indexOf(projectDetails.abandoned_at)) {
      warningText = 'Please complete previous section';
    } else {
      return null;
    }

    return (
      <span className="text-danger ms-3">
        <i className="fa fa-exclamation-triangle me-3" />
        {warningText}
      </span>
    );
  }

  handleExit() {
    const { projectResourceId } = this.props;

    if (this.isProjectDraft()) {
      this.handleSaveDraft();
    } else {
      window.location.href = `/projects/${projectResourceId}`;
    }
  }

  officeLocationText() {
    const { projectDetails } = this.state;
    let projectLocation = '';

    switch (projectDetails.work_location) {
      case 'office':
        return `At least ${projectDetails.office_days} days in the office (${projectDetails.office_location})`;
      case 'remote':
        return 'Remote';
      case 'hybrid':
        projectLocation += 'Hybrid';
        if (projectDetails.office_days) {
          projectLocation = `${projectLocation}, in office ${projectDetails.office_days} days / week `;
        }
        if (projectDetails.office_location) {
          projectLocation += ` at ${projectDetails.office_location}`;
        }
        return projectLocation;
      case 'both':
        return `Office and remote. At least ${projectDetails.office_days} days in the office (${projectDetails.office_location}).`;
      case 'not sure':
        return 'Workplace Preference';
      default:
        return 'Work preference';
    }
  }

  renderConfirmProjectDeletion() {
    return (
      <Fragment>
        <button
          className="btn btn-secondary-cancel button-delete"
          onClick={() => this.setState({ showConfirmDeletion: true })}
        >
          Delete Project
        </button>
        <Modal
          show={this.state.showConfirmDeletion}
          onHide={() => this.setState({ showConfirmDeletion: false })}
          id="confirm-deletion-modal"
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <div className="confirm-deletion-modal-body style-guide">
              <h2>Are you sure you want to delete this project?</h2>
              <div className="confirm-actions g-row--always">
                <div className="g-column g-flex-5">
                  <button
                    className="btn btn-default"
                    onClick={() => this.setState({ showConfirmDeletion: false })}
                  >
                    Back
                  </button>
                </div>
                <div className="g-column g-flex-2" />
                <div className="g-column g-flex-5">
                  <button
                    className="btn btn-tertiary"
                    onClick={this.handleDeleteProject}
                  >
                    Delete Project
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }

  renderButtons() {
    const deleteProjectPath = this.state.projectDetails.delete_project_path;

    let buttonText = 'Cancel';
    if (this.isProjectDraft()) {
      buttonText = 'Save as Draft';
    }

    return (
      <Fragment>
        <div className="project-review-buttons buttons-container d-md-none gap-3 py-4">
          {this.renderSubmit()}
          <button
            className="btn btn-secondary-no-border button-back"
            onClick={this.handleExit}
          >
            {buttonText}
          </button>
          { deleteProjectPath && this.renderConfirmProjectDeletion() }
        </div>
        <div className="project-review-buttons buttons-container d-none d-md-flex py-4">
          <div className="container d-none d-md-flex gap-3 justify-content-end">
            { deleteProjectPath && this.renderConfirmProjectDeletion() }
            <button
              className="btn btn-secondary-no-border button-back"
              onClick={this.handleExit}
            >
              {buttonText}
            </button>
            {this.renderSubmit()}
          </div>
        </div>
      </Fragment>
    );
  }

  renderErrors() {
    const { errors } = this.state;

    if (!errors || errors.length === 0) return null;
    return (
      <div id="error_explanation">
        <h3>Errors prohibited this project from being submitted:</h3>
        <ul>
          {errors.map((e) => <li>{e}</li>)}
        </ul>
      </div>
    );
  }

  renderSummaryBadge(label, priority) {
    const badgeType = (priority ? 'priority' : '');

    return (
      <span key={label} className={`badge ${badgeType}`}>
        {label}
      </span>
    );
  }

  renderEditLink(section, marginClass = null) {
    // if abandoned_at is not null, project is unfinished
    const redirectToReview = this.state.projectDetails.abandoned_at === null;

    return (
      <a
        role="link"
        tabIndex={0}
        onClick={this.props.handleUpdateSection(section, redirectToReview)}
        className={`medium-weight project-edit-link review-page ${marginClass}}`}
      >
        <i className="fa fa-edit" />
        Edit
      </a>
    );
  }

  renderSubmit(btnClass = '') {
    const { projectDetails } = this.state;
    let disabledState = '';

    if (projectDetails.abandoned_at === 'budget'
         || projectDetails.abandoned_at === 'logistics') {
      if (!projectDetails.work_location
          || !projectDetails.travel_time
          || !projectDetails.budget_minimum
          || !projectDetails.budget_maximum) {
        disabledState = 'disabled';
      }
    } else {
      disabledState = projectDetails.abandoned_at ? 'disabled' : '';
    }

    let buttonText = 'Save';
    if (this.isProjectDraft()) {
      buttonText = 'Submit Project';
    }

    return (
      <button
        className={`btn btn-primary button-submit review-submit text-white ${btnClass} ${disabledState}`}
        onClick={this.handleSubmit}
        disabled={disabledState}
      >
        {buttonText}
      </button>
    );
  }

  renderHeader() {
    const { projectDetails } = this.state;

    return (
      <div className="project-review-header">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
          <FeaturedProfileBanner
            consultantName={
              projectDetails.status === 'employer_draft' && projectDetails.favorited_consultant
                ? projectDetails.favorited_consultant : null
            }
          />
          <div className="project-review-buttons">
            {this.renderSubmit('header-submit-btn')}
          </div>
        </div>
      </div>
    );
  }

  renderSectionHeader(section) {
    let parentSection;
    if (section === 'About This Job' || section === 'Ideal Candidate') {
      parentSection = 'Responsibilities';
    } else if (section === 'Job Title and Role' || section === 'Length of Engagement') {
      parentSection = 'Start';
    } else {
      parentSection = section;
    }
    return (
      <h3 className="review-section-header">
        {section}
        {this.sectionWarning(parentSection)}
      </h3>
    );
  }

  renderNameSummary() {
    const { projectDetails } = this.state;
    const { seniority } = projectDetails;
    const { showFullTimeOption } = this.props;
    const role = projectDetails.higher_level_roles;
    return (
      <div className={cssClass(showFullTimeOption)}>
        <div>
          <div className="header-div">
            {this.renderSectionHeader('Project Title and Role')}
            {this.renderEditLink('start', 'ml')}
          </div>
          <div>
            {`Title - ${projectDetails.name}`}
          </div>
          <div>
            {`Role - ${role.length > 0 ? role.join(', ') : 'None'}`}
          </div>
          <div>
            {`Seniorities - ${seniority.length > 0 ? seniority.join(', ') : 'None'}`}
          </div>
        </div>
      </div>
    );
  }

  renderEngagementLength() {
    const { showFullTimeOption } = this.props;
    return (
      <div className={cssClass(showFullTimeOption)}>
        <div className="header-div">
          {this.renderSectionHeader('Length of Engagement')}
          {this.renderEditLink('start', 'ml')}
        </div>
        <div className="logistics-detail">
          <img className="mr-8 mb-4" src={clock} alt="clock-icon" />
          {this.durationText()}
        </div>
        <div className="logistics-detail">
          <img className="mr-8 mb-4" src={calender} alt="calender-icon" />
          {this.hoursText()}
        </div>
      </div>
    );
  }

  renderAboutJob() {
    const { showFullTimeOption } = this.props;
    const { projectDetails } = this.state;
    return (
      <div className={cssClass(showFullTimeOption)}>
        <div className="header-div">
          {this.renderSectionHeader('About This Job')}
          {this.renderEditLink('description')}
        </div>
        <div className="responsibility-text">
          {projectDetails.description || 'Description'}
        </div>
      </div>
    );
  }

  renderIdealCandidateDescription() {
    const { projectDetails } = this.state;
    const { showFullTimeOption } = this.props;
    return (
      <div className={cssClass(showFullTimeOption)}>
        <div className="header-div">
          {this.renderSectionHeader('Ideal Candidate')}
          {this.renderEditLink('description')}
        </div>
        <div className="responsibility-text">
          {projectDetails.description
            ? (
              <ul className="responsibilities-list">
                {listElementsToArray(projectDetails.ideal_candidate_description).map((text) => <li className="ml-4 mb-4" key={text}>{text}</li>)}
              </ul>
            )
            : 'Description'}
        </div>
      </div>
    );
  }

  renderExpertiseSummary() {
    const { projectDetails } = this.state;
    const { showFullTimeOption } = this.props;
    const priorityExpertiseTags = projectDetails.priority_expertise_tags;
    const nonPriorityExpertiseTags = projectDetails.non_priority_expertise_tags;
    const empty = (!priorityExpertiseTags || priorityExpertiseTags.length === 0)
                  && (!nonPriorityExpertiseTags || nonPriorityExpertiseTags.length === 0);
    const featuredContainer = 'feature-tag-section';

    return (
      <div className={`${cssClass(showFullTimeOption)} expertise-priority`}>
        <div className="header-div">
          {this.renderSectionHeader('Qualifications')}
          {this.renderEditLink('qualifications')}
        </div>
        {empty
          ? (
            <Fragment>
              Qualifications
              <div />
            </Fragment>
          )
          : (
            <div className={`tag-container ${featuredContainer}`}>
              {priorityExpertiseTags.map((label) => this.renderSummaryBadge(label, true))}
              {nonPriorityExpertiseTags.map((label) => this.renderSummaryBadge(label, false))}
            </div>
          )}
      </div>
    );
  }

  renderResponsibilitiesSummary() {
    const responsibilities = this.state.projectDetails.responsibility_areas;
    const { showFullTimeOption } = this.props;

    return (
      <div className={cssClass(showFullTimeOption)}>
        <div className="header-div">
          {this.renderSectionHeader('Responsibilities')}
          {this.renderEditLink('description')}
        </div>
        {(responsibilities === null || responsibilities.length === 0) && 'Responsibilities'}
        <div className="responsibility-text">
          <ul className="responsibilities-list">
            {responsibilities.map((text) => <li className="ml-4 mb-4" key={text}>{text}</li>)}
          </ul>
        </div>
        <div />
      </div>
    );
  }

  renderScopeSummary() {
    const { showFullTimeOption } = this.props;
    return (
      <div className={cssClass(showFullTimeOption)}>
        {this.renderSectionHeader('Scope')}
        {this.state.projectDetails.description || 'Description'}
        <div>{this.renderEditLink('scope', 'mt')}</div>
      </div>
    );
  }

  renderLogisticsSummary() {
    const { projectDetails } = this.state;
    const { showFullTimeOption } = this.props;

    return (
      <div className={cssClass(showFullTimeOption)}>
        {this.renderSectionHeader('Logistics')}
        <div className="logistics-detail">
          <i className="fas fa-map-marker-alt mr-8" />
          {this.officeLocationText()}
          {projectDetails.office_location_required && <b><i>&nbsp;*Must have</i></b>}
        </div>
        <div className="logistics-detail">
          <i className="fa fa-plane mr-8" />
          {this.travelLocationText()}
          {projectDetails.travel_location_required && <b><i>&nbsp;*Must have</i></b>}
        </div>
        <div className="logistics-detail">
          <i className="fas fa-clock mr-8" />
          {this.hoursText()}
        </div>
        <div className="logistics-detail">
          <i className="fas fa-calendar-day mr-8" />
          {this.durationText()}
        </div>
        <div>{this.renderEditLink('logistics')}</div>
      </div>
    );
  }

  renderBudgetSummary() {
    const { projectDetails } = this.state;
    const { showFullTimeOption } = this.props;
    const { seniority } = projectDetails;
    const min = projectDetails.budget_minimum;
    const max = projectDetails.budget_maximum;

    return (
      <div className={cssClass(showFullTimeOption)}>
        {this.renderSectionHeader('Budget')}
        {seniority.length > 0 ? seniority.join(' • ') : 'Seniority'}
        {' • '}
        {max && min ? `$${min} - $${max}` : 'Budget'}
        {this.renderEditLink('budget', 'ml')}
      </div>
    );
  }

  renderBudgetLogisticsSummary() {
    const { projectDetails } = this.state;
    const { showFullTimeOption } = this.props;
    const min = projectDetails.budget_minimum;
    const max = projectDetails.budget_maximum;

    return (
      <div className={cssClass(showFullTimeOption)}>
        <div className="header-div">
          {this.renderSectionHeader('Budget & Logistics')}
          {this.renderEditLink('budget & logistics')}
        </div>
        <img className="mr-8 mb-4" src={dollar} alt="dollar-icon" />
        { projectDetails.employment_type === 'full_time'
          ? `Base Salary - ${max && min ? `$${min.toLocaleString()} - $${max.toLocaleString()} /year` : 'Budget'}`
          : `Hourly Rate - ${max && min ? `$${min}-${max} /hour` : 'Budget'}`}
        { projectDetails.employment_type === 'full_time'
          ? (projectDetails.base_pay_hidden && ' (Hidden)')
          : (projectDetails.rate_negotiable && ' (Negotiable)')}
        {projectDetails.work_location
        && (
        <div>
          <div className="logistics-detail">
            <img className="mr-8 mb-4" src={mapIcon} alt="workplace-type" />
            { `${projectDetails.office_and_worktype_information}` }
          </div>
        </div>
        )}
        <div className="logistics-detail">
          <img className="mr-8 mb-4" src={travelPlane} alt="travel-icon" />
          {this.travelLocationText()}
        </div>
      </div>
    );
  }

  renderTeamSummary() {
    const { csrfToken, showFullTimeOption } = this.props;
    const { projectDetails, openTeamModal, pageSubmitted } = this.state;

    return (
      <div className={cssClass(showFullTimeOption)}>
        <h3>Team</h3>
        <AddCoworkersModal
          csrfToken={csrfToken}
          initialTeamMembers={projectDetails.initial_team_members}
          invitableRoles={projectDetails.invitable_roles}
          editableRoles={projectDetails.editable_roles}
          basePermissionsUrl={projectDetails.base_permissions_url}
          location="project-review"
          showModalCallback={() => { this.setState({ teamModalViewed: true }); }}
          hideModalCallback={this.handleAfterPublish}
          modalIsOpen={openTeamModal}
          pageSubmitted={pageSubmitted}
        />
      </div>
    );
  }

  renderAdminSummary() {
    const {
      projectResourceId, csrfToken, getProjectDetails, projectTypes, openAdminModal,
      showFullTimeOption,
    } = this.props;
    const { projectDetails } = this.state;

    let dateString;
    if (projectDetails.approximate_start_date_local) {
      dateString = new Date(`${projectDetails.approximate_start_date_local} 0:00`).toLocaleDateString();
    } else {
      dateString = 'ASAP';
    }

    return (
      <div className={`${cssClass(showFullTimeOption)} pb-5`} id="admin-section">
        <h3>Admin</h3>
        {`${projectDetails.project_type || '??'} • Starts ${dateString} • ${processTakeRate(projectDetails.clora_take_rate) || '??'}%`}
        <AdminModal
          formType="modal-link"
          projectResourceId={projectResourceId}
          csrfToken={csrfToken}
          getProjectDetails={getProjectDetails}
          afterSubmit={this.updateProjectDetails}
          projectTypes={projectTypes}
          modalOpen={openAdminModal}
        />
      </div>
    );
  }

  render() {
    const { projectDetails, loading } = this.state;
    const { homePath, showFullTimeOption } = this.props;
    if (!projectDetails || loading) {
      return (
        <ProjectLoadingIndicator />
      );
    }
    return (
      <Fragment>
        <ProjectDetailsNav displayExit={false} homePath={homePath} />
        <div className="project-details-screen container">
          {this.renderHeader()}
          { showFullTimeOption
            ? (
              <div className="style-guide project-review-container">
                <div className="project-review-body">
                  {this.renderErrors()}
                  <div className="new-summary-section">
                    <JobRoleAndTitleView
                      name={projectDetails.name}
                      role={projectDetails.higher_level_roles}
                      seniority={projectDetails.seniority}
                      employmentType={projectDetails.employment_type}
                      renderEditLink={() => this.renderEditLink('start', 'ml')}
                      showEditLink
                    />
                  </div>
                  {projectDetails.employment_type === 'consulting'
                  && (
                  <div className="new-summary-section">
                    <LengthOfEngagement
                      duration={projectDetails.duration_range}
                      avgTimeRequiredRange={projectDetails.avg_time_required_range}
                      renderEditLink={() => this.renderEditLink('start', 'ml')}
                      showEditLink
                    />
                  </div>
                  )}
                  {this.renderAboutJob()}
                  {this.renderIdealCandidateDescription()}
                  {this.renderResponsibilitiesSummary()}
                  {this.renderExpertiseSummary()}
                  <div className="new-summary-section">
                    <ProjectBudgetLogisticsView
                      employmentType={projectDetails.employment_type}
                      budgetMinimum={projectDetails.budget_minimum}
                      budgetMaximum={projectDetails.budget_maximum}
                      travelTime={projectDetails.travel_time}
                      travelLocation={projectDetails.travel_locations}
                      workLocation={projectDetails.work_location}
                      rateNegotiable={projectDetails.rate_negotiable}
                      basePayHidden={projectDetails.base_pay_hidden}
                      officeAndWorktypeInformation={projectDetails.office_and_worktype_information}
                      renderEditLink={() => this.renderEditLink('budget & logistics')}
                      officeLocation={projectDetails.office_location}
                      daysInOffice={projectDetails.days_in_office}
                      remotePreferredLocation={projectDetails.remote_preferred_location}
                      compensationBenefitNote={projectDetails.compensation_benefit_note}
                      showEditLink
                    />
                  </div>
                  {this.renderTeamSummary()}
                  {this.props.isAdmin && this.renderAdminSummary()}
                </div>
              </div>
            )
            : (
              <div className="edit-project-container">
                <div className="style-guide project-review-container">
                  <div className="g-row">
                    <div className="g-column g-flex-2" />
                    <div className="g-column g-flex-8 name-review-container">
                      {this.renderErrors()}
                      {this.renderNameSummary()}
                      {projectDetails.employment_type === 'consulting' && this.renderEngagementLength()}
                      {this.renderAboutJob()}
                      {this.renderIdealCandidateDescription()}
                      {this.renderResponsibilitiesSummary()}
                      {this.renderExpertiseSummary()}
                      {this.renderBudgetLogisticsSummary()}
                      {this.renderTeamSummary()}
                      {this.props.isAdmin && this.renderAdminSummary()}
                    </div>
                    <div className="g-column g-flex-2" />
                  </div>
                </div>
              </div>
            )}
          {this.renderButtons()}
        </div>
      </Fragment>
    );
  }
}

ProjectReview.propTypes = {
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  getProjectDetails: PropTypes.func.isRequired,
  handleUpdateSection: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  projectTypes: PropTypes.shape({}),
  isAdmin: PropTypes.bool,
  openAdminModal: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  homePath: PropTypes.string.isRequired,
  showFullTimeOption: PropTypes.bool,
};

ProjectReview.defaultProps = {
  projectResourceId: null,
  projectTypes: {},
  isAdmin: false,
  openAdminModal: false,
  showFullTimeOption: false,
};

export default ProjectReview;
